<template>
  <div class="modal-view">
    <div class="options">
      <div v-for="(values, name) in $store.getters.options" v-bind:key="name" :data-id="name">
        <div class="filter-name">{{ name | capitalize }}</div>
        <b-form-select @change="selectOption(name, $event)"
                       class="filter-select"
                       :options="values"
                       :placeholder="values[0]"
                       :value="values[0]" />
      </div>
    </div>
    <div class="action-buttons">
      <b-button variant="outline-primary" @click="closeModal">Close</b-button>
      <b-button variant="outline-primary" v-if="showReset"  @click="resetFilters">Reset</b-button>
      <b-button variant="outline-primary" :disabled="!hasChanged ? true : false" @click="applyFilters">Apply</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterModal',
  props: ['options'],
  data () {
    return {
      data: {},
      hasChanged: false,
      showReset: false,
    }
  },
  methods: {
    selectOption(filter, opt) {
      this.hasChanged = true
      this.data[filter] = opt
    },
    applyFilters() {
      // Copy __events array
      let events = this.$store.getters.__events.slice()

      let data = this.data
      let filtersChosen = false
      // Iterate over selected filters "data"
      Object.keys(data).forEach(function(option) {
        // Get specific filter chosen from input
        let chosenFilter = data[option]

        if (chosenFilter && !chosenFilter.startsWith('Select ')) {
          console.log('chosenFilter', chosenFilter)
          filtersChosen = true
          // Update `events` with data that matches filters
          events = getMatchingEvents(events, option, chosenFilter)
        }
      })

      // Choosing the first option (nothing) is the same as resetting
      if (!filtersChosen && this.$store.getters.eventsChanged) {
        this.resetFilters()
        return
      }

      function getMatchingEvents(events, option, chosenFilter) {
        let newEvents = []
        for (var item of events) {
          if (item.hasOwnProperty(option) && chosenFilter && item[option] === chosenFilter) {
            newEvents.push(item)
          }
        }
        return newEvents
      }

      this.$store.commit('setFilters', this.data)
      this.$store.commit('setEvents', events)

      this.checkResetAllowed()
    },
    resetFilters() {
      this.$store.commit('setFilters', {})
      this.$store.commit('resetEvents')

      // Clear the selected values manually
      for (var select of document.querySelectorAll('.filter-select')) {
        select.value = select.getAttribute('placeholder')
      }

      this.hasChanged = false
      this.checkResetAllowed()
    },
    checkResetAllowed() {
      this.showReset = Boolean(Object.keys(this.$store.getters.filters).length)
    },
    closeModal() {
      // Assume that the modal is open, so updating store should close it
      this.$store.commit('toggleShowFilterModal')
    }
  },
  created() {
    this.checkResetAllowed()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$gray: #343a40;
$spacing: 0.5rem;

.modal-view {
  z-index: 99999;
  width: 400px;
  height: 300px;
  position: absolute;
  border-radius: 20px;
  border: 5px $gray solid;
  background-color: $gray;
  color: #fff;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: 5px 5px rgba(0, 0, 0, 0.25);
  padding: $spacing;

  // display: flex;
  // align-items: center;

  .options {
    width: 100%;
    font-size: 1.25rem;

    .filter-name {
      border-bottom: 1px solid #fff;
      margin-bottom: $spacing;
    }
  }

  .action-buttons {
    position: absolute;
    right: $spacing;
    bottom: $spacing;
  }


}

@media screen and (max-width: 540px) {
  .modal-view {
    width: 300px;
    height: 300px;
    .message {
      font-size: 3rem;
    }
  }
}

@media screen and (max-width: 374px) {
  .modal-view {
    width: 250px;
    height: 250px;
    .message {
      font-size: 2.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/FilterModal.vue